import React from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from './styles';
import LoadingImage from 'assets/svg/loading.svg';
import CustomModal from 'components/custom-modal/CustomModal';
import CustomButton from 'components/common/custom-button/custom-button';
import { initialValues, validationSchema } from 'components/support/utils';
import { ErrorMessage, Form, Formik } from 'formik';
import { H5, P, SMALL } from 'utils/resuable-css';
import { useEditor, Editable } from '@wysimark/react';
// import ReactMarkdown from 'react-markdown';
import ReactMarkdown from 'markdown-to-jsx';
import { Base64 } from 'js-base64';

const IssueNotes = ({
  notesData,
  notesLoading,
  addTicketNotes,
  addNotesLoading,
  ticket,
  closeNoteModal,
  isOpenModal,
}) => {
  const ticketID = ticket?.tickets[0]?.id;
  const editor = useEditor({ minHeight: 300 });

  return (
    <Styles.DraggableContainer id="alertParent">
      <div>
        <div id="alertChild">
          <Styles.TopBar>
            <Styles.Left>
              <Icon name="user" color="black" />
              <H5>Notes about this ticket</H5>
              <P className="count">{notesData?.count}</P>
              {notesLoading && <img src={LoadingImage} height={28} alt="loading" />}
            </Styles.Left>
          </Styles.TopBar>
        </div>
        <Styles.Content>
          {notesData?.notes?.map((val, i) => (
            <Styles.NotificationContainer key={i}>
              <Styles.Alert>
                <P>
                  {val.closing_note === '1' && 'CLOSING NOTE:'}{' '}
                  <ReactMarkdown className="line-break">{Base64.decode(val.note)}</ReactMarkdown>
                </P>
                <SMALL>
                  <br />
                  {val.date_local_format_mdy}; {val.date_ago_en}
                </SMALL>
              </Styles.Alert>
            </Styles.NotificationContainer>
          ))}
        </Styles.Content>
      </div>
      <Styles.TradeContainer onClick={() => closeNoteModal()}>
        <P>Add a note to this ticket</P>
      </Styles.TradeContainer>
      <CustomModal heading="New note" open={isOpenModal} onClose={() => closeNoteModal()}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values) => await addTicketNotes(ticketID, values.notes)}
        >
          {({ setFieldValue, values }) => (
            <Form>
              <Styles.ModalContainer>
                <ErrorMessage name={'notes'} render={(msg) => <span className="error_messageSty">{msg}</span>} />
                <Styles.TextArea>
                  <Editable
                    value={values.notes}
                    placeholder={'please write a note here'}
                    editor={editor}
                    onChange={() => setFieldValue('notes', editor.getMarkdown())}
                  />
                  {/* <textarea
                    name={'notes'}
                    value={values['notes']}
                    placeholder={'please write a note here'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors['notes']}
                    touched={touched['notes']}
                    rows="10"
                  /> */}
                </Styles.TextArea>
                <CustomButton
                  type="submit"
                  title="submit note"
                  buttonStyles={{
                    float: 'right',
                  }}
                  isLoading={addNotesLoading}
                />
              </Styles.ModalContainer>
            </Form>
          )}
        </Formik>
      </CustomModal>
    </Styles.DraggableContainer>
  );
};
export default IssueNotes;
